import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Chip, Stack } from '@mui/material';
import { FinanceFilters, FinanceFilterType } from '../types';
import { DATE_RANGE_OPTIONS } from 'modules/finance/performance/constants';
import { FinanceDateRange } from 'modules/finance/performance/types';

export const FinanceDealDateRange = () => {
  const { control, setValue } = useFormContext<FinanceFilters>();
  const current = useWatch({ control, name: FinanceFilterType.DEAL_DATE });

  return (
    <Stack direction="row" gap="0.5rem" flexWrap="wrap">
      {DATE_RANGE_OPTIONS.map(opt => (
        <Chip
          key={opt.value}
          label={opt.label}
          size="small"
          onClick={() => setValue(FinanceFilterType.DEAL_DATE, opt.value as FinanceDateRange)}
          variant={current === opt.value ? 'filled' : 'outlined'}
          color={current === opt.value ? 'primary' : 'default'}
          sx={{ fontSize: 11, fontWeight: 500, height: 26, cursor: 'pointer' }}
        />
      ))}
    </Stack>
  );
};
